export default "__VITE_ASSET__B37WKC85__"